// Module
var code = "<p>Interest Notices differ from bills because you&#39;re not required to make a payment if your loan is in deferment, forbearance, grace, or in-school status.</p> ";
// Exports
export default code;